import React, { useEffect } from 'react';
import { useState } from 'react'
import Footer from "../../MyComponents/Footer";
import GuestNav from "../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../MyComponents/Hero2";
import heroContent from './HeroContent';
import leftimg from "../../assets/businessleftimg.png"
import rightimg from "../../assets/businessrightimg.png"
import kidimg from "../../assets/kidimg.png"
import digitalimg from "../../assets/digitalimg.png"
import funimg from "../../assets/funimg.png"
import Eimg from "../../assets/Eimg.png"
import CourseExplorer from '../../MyComponents/CourseExplorer';
import Testimonials from '../../MyComponents/Testimonials';
import FAQs from '../../MyComponents/FooterPages/newfaq';
const courses = [
  { title: "KidPrenur", image: kidimg },
  { title: "Digital Marketing", image: digitalimg },
  { title: "Fun Finance", image: funimg },
  { title: "E-Commerce", image: Eimg }
 
 
];
const BusinessPortal = () =>{
    const businesspage = heroContent.businesspage;
      return (
         <>
           <GuestNav />
           <Hero2
             titlePart1={businesspage.titlePart1}
             titlePart2={businesspage.titlePart2}
             description={businesspage.description}
             buttonText={businesspage.buttonText}
             leftImage={leftimg}
             rightImage={rightimg}
            />
             <CourseExplorer
                    title="Explore Our Fun & Skill-Boosting Entrepreneurship Courses"
                    highlightText="Entrepreneurship Courses"
                    courses={courses}
                  />
                  <Testimonials/>
                  <FAQs/>
          <Footer /> 
         </>
       );
  }
  export default BusinessPortal